import { createAction } from '@reduxjs/toolkit';
import { RoomReactionsReceivedPayload } from 'features/room-reactions/types';
import { SignalingEventPayload } from 'services/signaling';

export const signalingRoomReactionsReceived = createAction<
  SignalingEventPayload<RoomReactionsReceivedPayload>
>('signaling/roomReactions/reactionsReceived');
